import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="grid-bg flex min-h-screen flex-col items-center justify-center bg-gb-black px-6 text-center" data-testid="not-found-page">
      <p className="chrome-text font-display text-8xl font-extrabold sm:text-9xl">404</p>
      <h1 className="mt-6 font-display text-xl font-bold sm:text-2xl">Esta página não foi encontrada</h1>
      <p className="mt-3 max-w-sm text-sm text-gb-gray">
        O endereço que você acessou não existe ou foi movido.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="btn-chrome mt-9 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Voltar para o início
      </Link>
    </div>
  );
}
